<template>
	<div class="container text-center">
		<img
			alt="Vue logo"
			src="https://1000logos.net/wp-content/uploads/2019/05/Avengers-logo.png"
      class="home-logo"
		/>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from "vue";

	export default defineComponent({});
</script>
